
<mat-form-field appearance="outline">
  <input matInput placeholder="Enter Your GMC Number"
                  (input)="onChange()"
                  [value]="gmcNumber"
                  [disabled]="disabled"
                  i18n-placeholder
  >
</mat-form-field>
